export function getMagnusToken(): string {
    return process.env.REACT_APP_MAGNUS_TOKEN!;
  }
  